import { Singleton } from '@core/decorators/Singleton.decorator';

@Singleton
class EnvironmentService {
  public get baseUrl() {
    return process.env.BASE_URL;
  }
  public get flowId() {
    return process.env.FLOW_ID;
  }
  public get clientId() {
    return process.env.CLIENT_ID;
  }
}

const environmentService = new EnvironmentService();

export { environmentService };
